module.exports = __webpack_public_path__ + "5126f2a021a0cb39f74c0db692e6eeae.svg";